import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const EditCategories = ({ onClose, categoryId, fetchCategories }) => {
  const [formData, setFormData] = useState({
    name: "",
  });

  const popupRef = useRef(null);

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await axios.get(
          `/api_w/postcategories/${categoryId}`,
          {
            headers: {
              db_name: process.env.REACT_APP_DB_NAME,
            },
          }
        );
        const postData = response.data.data;
        setFormData({
          name: postData.name,
        });
      } catch (error) {
        toast.error(
          "Error fetching kategori: " +
            (error.response?.data?.message || error.message)
        );
      }
    };

    if (categoryId) {
      fetchCategory();
    }

    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [categoryId, onClose]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const config = {
      method: "put",
      url: `/api_w/postcategories/${categoryId}`,
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
        db_name: process.env.REACT_APP_DB_NAME,
      },
      data: JSON.stringify(formData),
    };

    try {
      const response = await axios.request(config);
      console.log(JSON.stringify(response.data));
      toast.success("Berhasil Edit Kategori!");
      fetchCategories();
      onClose();
    } catch (error) {
      toast.error(
        "Error Edit Kategori: " +
          (error.response?.data?.message || error.message)
      );
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/50">
      <form
        ref={popupRef}
        onSubmit={handleSubmit}
        className="mx-4 w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl"
      >
        <h3 className="mb-5 text-lg font-bold text-navy-700">Edit Kategori</h3>
        <div className="mb-5">
          <label className="mb-1.5 block text-sm font-semibold text-navy-700">
            Nama Kategori
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Masukkan nama kategori..."
            className="block w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm outline-none focus:border-brand-500 focus:ring-0 transition-colors"
            required
          />
        </div>
        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="rounded-xl border border-gray-200 px-5 py-2.5 text-sm font-semibold text-gray-600 hover:bg-gray-50 transition-colors"
          >
            Batal
          </button>
          <button
            type="submit"
            className="rounded-xl px-5 py-2.5 text-sm font-bold text-white transition-all hover:opacity-90"
            style={{ background: "linear-gradient(to right, #16a34a, #15803d)" }}
          >
            Simpan Perubahan
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditCategories;
